import { Component, computed, DestroyRef, inject, input, output, signal, viewChild } from '@angular/core';
import { OrganizationDetailsComponent } from 'src/app/features/organization/components/organization-details/organization-details.component';
import { Organization, OrganizationDisplay } from 'src/app/features/organization/organization-models';
import { TextSearchComponent } from '../../../text-search/text-search.component';
import { Observable } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButton } from '@angular/material/button';
import { CardComponent } from 'ok-angular-shared/components';

@Component({
  selector: 'adm-tab-departments',
  templateUrl: './tab-departments.component.html',
  styleUrls: ['./tab-departments.component.scss'],
  imports: [OrganizationDetailsComponent, TextSearchComponent, MatButton, CardComponent],
})
export class TabDepartmentsComponent {
  private destroyRef = inject(DestroyRef);
  private textSearch = viewChild(TextSearchComponent);
  public organizationDetails = viewChild(OrganizationDetailsComponent);

  organization = input.required<Organization>();
  closeDialogRequested = output<void>();
  departmentFilter = signal('');

  organizationDisplay = computed<OrganizationDisplay>(() => ({
    ...this.organization(),
    enabled: true,
  }));

  onSearch(search$: Observable<string>) {
    search$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(term => {
      this.departmentFilter.set(term);
    });
  }

  resetFilter() {
    this.textSearch()?.reset();
  }
}
